module.exports = __webpack_public_path__ + "static/media/sf_2900.f32736df4f655d99229b14d13d10eebb.png";